import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Element } from './element';
const json = require("json!./../../../../resources/properties.json");

@Injectable()
export class DashboardService {

    private _elementsUrl = '/elementData';
    private _profileUrl = '/profileData';
    private serverURL: string;

    constructor(private http: Http) {
        this.serverURL = json.api_url;
    }

    getElement() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + this._elementsUrl, options)
            .toPromise()
            .then(res => { return JSON.parse(res.text()).row[0]; }, this.handleError);
    }

    getProfile() {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        let options = new RequestOptions({ headers: authHeader, body: "" });
        return this.http.get(this.serverURL + this._profileUrl, options)
            .toPromise()
            .then(res => { return JSON.parse(res.text()) }, this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || {};
    }

    editElement(element: Element) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        return this.http.put(this.serverURL + this._elementsUrl + "/" + element.id, this.serializeObj(element), {
            headers: authHeader
        })
            .subscribe(res => { console.log(res); });
    }

    postName(name: string) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        return this.http.put(this.serverURL + this._elementsUrl + "/name", this.serializeObj({ "comercial_name": name }), {
            headers: authHeader
        })
            .subscribe(res => { console.log(res); });
    }

    postDescription(description: string) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        return this.http.put(this.serverURL + this._elementsUrl + "/description", this.serializeObj({ "description": description }), {
            headers: authHeader
        })
            .subscribe(res => { console.log(res); });
    }

    editWebSite(web: string) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        return this.http.put(this.serverURL + this._elementsUrl + "/web", this.serializeObj({ "web": web }), {
            headers: authHeader
        })
            .subscribe(res => { console.log(res); });
    }

    editFacebookSite(facebook: string) {
        var token = localStorage.getItem('token');
        var authHeader = new Headers({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        if (token) {
            authHeader.append('Authorization', 'Bearer ' + token);
        }
        return this.http.put(this.serverURL + this._elementsUrl + "/facebook", this.serializeObj({ "facebook": facebook }), {
            headers: authHeader
        })
            .subscribe(res => { console.log(res); });
    }

    private handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

    private serializeObj(obj: any) {
        var result: any[] = [];

        for (var property in obj)
            result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

        return result.join("&");
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/super_user/dashboard/dashboard.service.ts
 **/